import { DefaultModelIcon, QwenIcon } from "../components/icons";
import { PerplexityIcon } from "../components/icons";
import { 
  ChatGPTIcon, 
  GeminiIcon, 
  CloudIcon, 
  DeepSeekIcon, 
  GrokIcon,
  LlamaIcon,
  MistralIcon
} from "../components/icons";
import { ScoresEveryDayBrandItem } from "./scores";
import { ScoreWeekly } from "../store/scores/types";

export type Model = {
  id: string;
  name: string;
  description: string;
  is_active: boolean;
  created_at: string;
  model_id: string;
  deleted_at: string | null;
  data: ModelData;
  scores: ScoresEveryDayBrandItem;
  firstDate: string;
  title: string;
  weeklyScores: ScoreWeekly | null;
  is_active_user: boolean;
  tier?: 'standard' | 'pro';
}

export type ModelData = {
  type: ModelIcons;
  version: string;
}

export enum ModelIcons {
  CHATGPT = "chatgpt",
  GROK = "grok",
  CLAUDE = "claude",
  DEEPSEEK = "deepseek",
  GEMINI = "gemini",
  PERPLEXITY = "perplexity",
  LLAMA = 'llama',
  QWEN = 'qwen',
  MISTRAL = 'mistral',
}

export const mapModelIcon = (icon: ModelIcons) => {
  switch (icon) {
    case ModelIcons.CHATGPT:
      return ChatGPTIcon;
    case ModelIcons.GROK:
      return GrokIcon;
    case ModelIcons.CLAUDE:
      return CloudIcon;
    case ModelIcons.DEEPSEEK:
      return DeepSeekIcon;
    case ModelIcons.GEMINI:
      return GeminiIcon;
    case ModelIcons.PERPLEXITY:
      return PerplexityIcon;
    case ModelIcons.LLAMA:
      return LlamaIcon;
    case ModelIcons.QWEN:
      return QwenIcon;
    case ModelIcons.MISTRAL:
      return MistralIcon;
    default:
      return DefaultModelIcon;
  }
}